import { render, staticRenderFns } from "./GwernDecor.vue?vue&type=template&id=09f979c0&"
import script from "./GwernDecor.vue?vue&type=script&lang=ts&"
export * from "./GwernDecor.vue?vue&type=script&lang=ts&"
import style0 from "./GwernDecor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports